const getSelectedValues = (options) => {
  const result = [];
  if (options) {
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

export const diffSubscription = (a, b, keys) => {
  if (a) {
    if (b) {
      return keys.some((key) => a[key] !== b[key]);
    }
    return true;
  }
  return !!b;
};

export const getValue = (e, current, valueProp, isNative) => {
  if (!isNative() && e.nativeEvent && e.nativeEvent.text !== undefined) {
    return e.nativeEvent.text;
  }
  if (isNative() && e.nativeEvent) {
    return e.nativeEvent.text;
  }

  const detyped = e;
  const {
    target: { checked, type, value },
  } = detyped;
  switch (type) {
    case 'checkbox':
      if (valueProp !== undefined) {
        if (checked) {
          return Array.isArray(current)
            ? current.concat(valueProp)
            : [valueProp];
        }
        if (!Array.isArray(current)) {
          return current;
        }
        const index = current.indexOf(valueProp);
        if (index < 0) {
          return current;
        }
        return current.slice(0, index).concat(current.slice(index + 1));
      }
      return !!checked;

    case 'select-multiple':
      return getSelectedValues(e.target.options);
    default:
      return value;
  }
};

export const defaultFormat = (value, name) =>
  value === undefined ? '' : value;
export const defaultParse = (value, name) => (value === '' ? undefined : value);
